/**
 * Google Analytics 4 (GA4) event tracking for the Pokemon GO tier list site.
 * Only sends events in production; safe to call in all environments.
 */

const GA_MEASUREMENT_ID = 'G-4EH5C69EZB';

function isEnabled() {
  return typeof window !== 'undefined' && window.gtag && process.env.NODE_ENV === 'production';
}

/**
 * Send a GA4 event. Event name and params are passed through to gtag.
 * No-op when gtag is unavailable or in development.
 */
export function trackEvent(eventName, eventParams = {}) {
  if (!isEnabled()) return;
  try {
    window.gtag('event', eventName, eventParams);
  } catch (e) {
    // Avoid breaking app if gtag fails
  }
}

/**
 * Send a virtual page view (e.g. for SPA route changes).
 */
export function trackPageView(path, title) {
  if (!isEnabled()) return;
  try {
    window.gtag('event', 'page_view', {
      page_path: path || window.location.pathname,
      page_title: title || document.title,
    });
  } catch (e) {
    // no-op
  }
}

// --- Named events for key interactions ---

export function trackLoginClick() {
  trackEvent('login_click');
}

export function trackLoginSuccess() {
  trackEvent('login_success');
}

export function trackLogout() {
  trackEvent('logout');
}

export function trackTierListView(type) {
  trackEvent('tier_list_view', { type: type || '' });
}

export function trackPokemonView(pokemonName) {
  trackEvent('pokemon_view', { pokemon_name: pokemonName || '' });
}

export function trackRaidBossOpen(initialBoss = null) {
  trackEvent('raid_boss_open', initialBoss ? { initial_boss: initialBoss } : {});
}

export function trackRaidBossSimulate(bossName) {
  trackEvent('raid_boss_simulate', { boss_name: bossName || '' });
}

export function trackRaidBossClose() {
  trackEvent('raid_boss_close');
}
